import { postApi } from "./api_instance";

export const counterofferRejectPostApi = async (data, dispatch) => {
  try {
    return await postApi({
      apiUrl: "/projects/api/myBids/rejected-Countered-Offer-OnBid",
      sendToken: true,
      dispatch,
      data,
    });
  } catch (error) {
    throw error;
  }
};
